// extracted by mini-css-extract-plugin
module.exports = {"text":"ColumnsBlock-module--text--3H1x0","image":"ColumnsBlock-module--image--3I6Sm","imageRounded":"ColumnsBlock-module--imageRounded--1-9eV"};